import { Category } from '@wix/answers-api';
import { Box } from '@wix/design-system';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { FunctionComponent, useEffect } from 'react';

import { SearchInput } from './SearchInput';
import { SkeletonLoading } from './SkeletonLoading';
import { ArticleSearchResult } from '../../types';
import { ContactSupport } from '../ContactSupport';
import SearchResultItems from './SearchResultItems';
const GeneratedAnswerV2 = dynamic(() => import('./GeneratedAnswer'), { ssr: false });

import css from './index.module.scss';

type SearchResultsV2Props = {
  isContactSupport: boolean;
  isLoading: boolean;
  searchResults: ArticleSearchResult;
  categoriesPaths: Record<string, Category[]>;
  locale: string;
  generatedAnswer: string | null;
  isProhibited: boolean | null;
  isStreaming?: boolean;
  usedArticlesInfo: { [id: string]: string };
  retryGenerateAnswer: () => Promise<void>;
  onSearch: (newTerm: string) => void;
  initialSearchTerm?: string;
};

export const SearchResultsV2: FunctionComponent<SearchResultsV2Props> = ({
  isContactSupport,
  isLoading,
  searchResults,
  categoriesPaths,
  generatedAnswer,
  isProhibited,
  isStreaming,
  usedArticlesInfo,
  retryGenerateAnswer,
  onSearch,
  initialSearchTerm,
}) => {
  const { searchMethod } = searchResults;
  const {
    query: { term },
  } = useRouter();
  const decodedTerm = term ? decodeURIComponent(term as string) : '';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box className={css.searchResultsWrapper}>
      <Box className={css.searchResultsWrapperInner} align="center">
        <Box className={css.searchResultsContent} direction="vertical">
          <SearchInput
            initialSearchTerm={initialSearchTerm}
            retryGenerateAnswer={retryGenerateAnswer}
            onSearch={onSearch} />
          {isContactSupport ? (
            <ContactSupport searchMethod={searchMethod as string} />
          ) :
            <GeneratedAnswerV2
              searchAnswer={generatedAnswer}
              isProhibited={isProhibited}
              isStreaming={isStreaming || isLoading}
              usedArticlesInfo={usedArticlesInfo}
              searchQuestion={decodedTerm}
              retryGenerateAnswer={retryGenerateAnswer}
            />
          }
          {searchResults.items.length === 0 || searchResults.isLoading ? (
            <SkeletonLoading />
          ) : (
            <SearchResultItems
              searchResults={searchResults}
              categoriesPaths={categoriesPaths}
            />
          )}
        </Box>
      </Box>
    </Box>);
};
